import { render, staticRenderFns } from "./prompt_selector.vue?vue&type=template&id=2b3159b8"
import script from "./prompt_selector.vue?vue&type=script&lang=js"
export * from "./prompt_selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports